import * as yup from 'yup';
import moment from 'moment';
import { t } from "i18next";

const requiredFieldError = t("common.form.errors.mandatory_field");
const emailFieldError = t("common.form.errors.invalid_email");
const numberFieldError = t("user_profile_page.errors.not_a_number");
const invalidNumberError = t("common.form.errors.invalid_federative_license")
const requiredFieldErrorNumber = t("user_profile_page.errors.invalid_number");

export const validationSchema = yup.object().shape({
   name: yup.string()
       .trim()
       .required(requiredFieldError),
   doesPhoneExist: yup.boolean(),
   phone: yup.string().when('doesPhoneExist', {
      is: false,
      then: yup.string()
          .required(requiredFieldError)
          .matches(/^[0-9]+$/, numberFieldError)
          .min(9, t("common.form.errors.invalid_phone_number")),
   }),
   doesBirthyearExist: yup.boolean(),
   birthyear: yup.string().when('doesBirthyearExist', {
      is: false,
      then: yup.string(numberFieldError)
          .typeError(requiredFieldErrorNumber)
          .required(requiredFieldError)
          .test({
             name: "Birthyear error",
             message: t("common.form.errors.invalid_year"),
             test: value => {
                let birthyear = parseInt(value);
                return birthyear > moment().year() - 70 && birthyear < moment().year() - 12
             }
          })
   }),
   gender: yup
       .string()
       .typeError(requiredFieldError)
       .required(requiredFieldError)
       .oneOf(["Masculino", "Feminino"], requiredFieldError),
   offerId: yup.string().when('welcomePackNeeded', {
      is: true,
      then: yup.string()
          .required(requiredFieldError)
          .matches(/^(?!(DEFAULT)$).+$/, requiredFieldError),
      otherwise: yup.string().notRequired()
   }),
   offerSizeId: yup.string().when('welcomePackNeeded', {
      is: true,
      then: yup.string()
          .required(requiredFieldError)
          .matches(/^(?!(DEFAULT)$).+$/, requiredFieldError),
      otherwise: yup.string().notRequired()
   }),
   fppLicence: yup.string().when('hasFppLicence', {
      is: true,
      then: yup
          .string(numberFieldError)
          .required(requiredFieldError)
          .matches(/[0-9]*(?:[^0]+)/, invalidNumberError),
      otherwise: yup.string().notRequired()
   }),
   email: yup
       .string()
       .trim()
       .required(requiredFieldError)
       .email(emailFieldError)
       .notOneOf([yup.ref('loggedUserEmail')], t("substitution_request_page.errors.own_email")),
   facebook: yup
       .string()
       .trim()
       .when('hasSocialMedia', {
          is: true,
          then: yup
              .string()
              .required(requiredFieldError)
              .matches(
                  /^[A-Za-z0-9.]*$/,
                  t("user_profile_page.errors.invalid_facebook")
              ),
          otherwise: yup.string().notRequired()
       }),
   authToShareSubInfo: yup.bool().oneOf([true], requiredFieldError),
   fppLicenceIsValid: yup.bool().oneOf([true], requiredFieldError)
});

export default validationSchema;
